import { ptBR } from '@/i18n/pt-BR';
import type { PreAnaliseRecordData, Tendencia } from '@/lib/pre_analise';
import { rotuloDaTendencia } from '@/lib/veredito';

/**
 * Rótulo da tendência — desde a E59 vem da fonte única do veredito, para que a
 * triagem, o portal e a área do certificador digam a MESMA palavra sobre o
 * mesmo estado. O `Record` permanece porque os consumidores indexam por
 * tendência.
 */
export const TENDENCIA_LABEL: Record<Tendencia, string> = {
  compatibilidade: rotuloDaTendencia('compatibilidade'),
  inconclusivo: rotuloDaTendencia('inconclusivo'),
  divergencia: rotuloDaTendencia('divergencia'),
};

/**
 * Resumo PRELIMINAR em texto plano, rotulado NÃO-PERICIAL — para o perito copiar
 * e encaminhar ao requerente (decisão owner 2026-06-30: compartilhável = artefato
 * copiável, sem e-mail). Nunca é laudo; nunca expõe LR.
 */
export function buildShareableSummary(preAnalise: PreAnaliseRecordData): string {
  const tendencia = TENDENCIA_LABEL[preAnalise.tendencia];
  return [
    ptBR.preAnalise.shareableHeader,
    '',
    `${ptBR.preAnalise.shareableIndicativoLabel}: ${preAnalise.indicativo_percentual}% (${tendencia})`,
    '',
    preAnalise.sintese,
    '',
    ptBR.preAnalise.shareableFooter,
  ].join('\n');
}
